import { safeReadingTags } from "../../../shared/reading-privacy";
import * as Sentry from "@sentry/react";
// A console event whose arguments are ("event_name", { details }) becomes an event named
// event_name with the details as tags; anything else passes through unchanged.
export function shapeEvent(event: Sentry.ErrorEvent) {
  const args = event.extra?.arguments;
  if (!Array.isArray(args) || typeof args[0] !== "string") return event;
  const details = typeof args[1] === "object" && args[1] !== null ? args[1] as Record<string, unknown> : {};
  event.message = args[0];
  event.tags = { ...event.tags, ...Object.fromEntries(Object.entries(details).map(([key, value]) => [key, String(value)])) };
  event.extra = details;
  // One issue per event and reason, instead of every fallback reason sharing one issue.
  event.fingerprint = [args[0], ...(typeof details.reason === "string" ? [details.reason] : [])];
  return event;
}

const allowed = new Set(["reason", "elapsedMs", "attempt", "preloaded", "contextState", "seconds", "expectedWords", "actualWords"]);
export function readingDiagnostic(name: string, details: Record<string, unknown> = {}) {
  const safe = Object.fromEntries(Object.entries(details).filter(([key, value]) => allowed.has(key) && (typeof value === "number" || typeof value === "boolean" || typeof value === "string" && /^[a-z_]+$/.test(value))));
  Sentry.captureEvent(shapeEvent({ type: undefined, message: name, tags: safeReadingTags(details), extra: { arguments: [name, safe] } }));
}
